import { useQuery } from 'react-query';
import createCachedSelector from 're-reselect';
import * as api from '../../services/api';
import { SORT_BY_STRING } from '../../utils/sorting';
import useAccount from './useAccount';

const selector = createCachedSelector(
  (data) => data.data,
  (data) => {
    const labelSorter = SORT_BY_STRING('label');

    const subLocationsOptions = (data?.subLocations || [])
      .map(({ id, name }) => ({ value: id, label: name }))
      .sort(labelSorter);

    const mappedSubLocations = (data?.subLocations || []).reduce(
      (prev, { id, ...subLocation }) => ({
        ...prev,
        [id]: { ...subLocation, id }
      }),
      {}
    );

    return { location: data, subLocationsOptions, mappedSubLocations };
  }
)({
  keySelector: (_, clientId, clientBranchId, locationId, storeKey) => storeKey.join('#')
});

const useClientSpecificLocation = ({
  clientId,
  clientBranchId,
  locationId,
  enabled = true,
  withAttachments = false
} = {}) => {
  const { accountId } = useAccount();
  const storeKey = ['client-specific-location', accountId, clientId, clientBranchId, locationId];

  const { isLoading, data } = useQuery(
    storeKey,
    () => api.fetchClientSpecificLocation({ accountId, clientId, clientBranchId, locationId, withAttachments }),
    {
      staleTime: 0,
      enabled: !!enabled && !!clientId && !!locationId && !!clientBranchId,
      select: (locationsData) => selector(locationsData, clientId, clientBranchId, locationId, storeKey)
    }
  );

  const { location, subLocationsOptions, mappedSubLocations } = data || {};

  return {
    isLoading,
    data: location,
    subLocations: location?.subLocations,
    subLocationsOptions,
    mappedSubLocations
  };
};

export default useClientSpecificLocation;
